<script setup>
import {Head} from '@inertiajs/vue3';
import WebPageLayout from "@/Layouts/WebPageLayout.vue";
import LightboxGallery from "@/Components/Lightbox-gallery.vue";
import PrimaryButton from "@/Components/PrimaryButton.vue";

defineProps(['prijzen', 'beschikbaarheden_verjaardag'])

</script>

<template>
    <Head title="Verjaardagsfeest">
        <meta content="Verjaardagsfeest" name="title">
        <meta
            content="Jarig? En wil je een onvergetelijk feest tussen de dieren? Ontdek onze verjaardagsformule en geniet van een ervaring die je nog lang zal bijblijven."
            name="description">
        <meta content="index, follow" name="robots">
    </Head>

    <WebPageLayout>
        <div>
        <div class="flex flex-col md:flex-row md:gap-4">
            <div class="md:w-4/6">
                <blockquote>
                    <h4>Hallo jij daar,
                    gelukkige verjaardag!</h4>
                    <p>Kom gerust langs met al jouw vriendjes om jouw verjaardag spetterend te vieren! Beleef de
                        mooiste verjaardag sinds tijden.</p>
                    <p><strong>Vanaf 2022 hebben we een nieuw concept omtrent de verjaardagsfeestjes.</strong></p>
                    </blockquote>
            </div>
        </div>

        <div class="flex flex-col md:flex-row md:gap-4">
            <div class="panel md:w-4/6">
                <h4 class="bg-[#F6EEBA] text-center p-2 text-kvpDanger">Prijs: €{{ prijs_kind.prijs.toFixed(0) }}/kind (met
                een minimum van €{{ prijs_groep.prijs.toFixed(0) }}/groep =
                {{ Math.round(prijs_groep.prijs.toFixed(0) / prijs_kind.prijs.toFixed(0)) }}
                deelnemers),<br/>
                alles (activiteiten, eten, drank) inclusief.</h4>

            <h3 class="subheader">Hoe zal zo een verjaardagsfeestje verlopen?</h3>
            <p>Als alle verwachte deelnemende kinderen aanwezig zijn, vertrekken we via het steegje naar de grote
                weide.</p>
            <p><em>In de weide:</em></p>
            <ul class="bday">
                <li>mogelijkheid om dierenvoeder klaar te maken: snijden van stukjes fruit, brood, groenten,...</li>
                <li>kennis maken met de grote dieren (ezels, herten, nandoes, emoe, lama’s, koeien, geiten, schapen,paarden en pony’s, varkens, ...)                </li>
                <li>Geitjes aaien onder begeleiding</li>
                <li>Ritje op paard/pony in de paardenpiste</li>
                <li>Huifkar/treintje</li>
                <li>Mogelijkheid om op de speeltoestellen te spelen (schommel, molentje, go-car, glijbaan, zandbak,basket,...)</li>
            </ul>

                <h4>De maaltijden van de kinderen zullen vanaf ongeveer 16:00 (of 12:00) in buffetvorm aangeboden worden
                    waarbij ze de keuze hebben uit: </h4>
                <ul class="bday">
                    <li>Hot-dog</li>
                    <li>Frietjes met frikandel</li>
                    <li>Fingerfood (Kippenboutjes, calamares, &hellip;)</li>
                    <li>Pannenkoek</li>
                    <li>Pasta</li>
                    <li>Soep</li>
                </ul>
                <p><strong>De kinderen mogen zo vaak als ze willen opnieuw aanschuiven aan het buffet. Ook drank wordt
                    er <em>à volonté</em> aangeboden. Begeleidende volwassenen kunnen voor 5€/pp ook deelnemen aan het
                    buffet.</strong></p>

                <div>
                    <h3 class="subheader">Beschikbare data {{ new Date().getFullYear() }}.</h3>
                    <table class="w-full table-auto" v-if="filteredDitJaar.length > 0">
                        <thead>
                        <tr>
                            <th>Dag</th>
                            <th>Datum</th>
                            <th>Startuur</th>
                            <th>Einduur</th>
                            <th class="flex flex-row justify-center">Volzet/vrij</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="dag in filteredDitJaar"
                            :class="{ 'doorstreept': new Date(dag.startdatum) <= new Date()}"
                            :key="dag.id">
                            <td>{{ weekdagen[new Date(dag.startdatum).getDay()] }}</td>
                            <td>{{
                                    new Date(dag.startdatum).toLocaleDateString('nl-BE', {
                                        year: 'numeric',
                                        month: 'long',
                                        day: 'numeric'
                                    })
                                }}
                            </td>
                            <td>{{ dag.startuur.substring(0, 5) }}</td>
                            <td>{{ dag.einduur.substring(0, 5) }}</td>
                            <td v-if="getVolzet(dag)" class="flex flex-row justify-center">
                                <span>VOLZET</span>
                            </td>
                            <td v-else class="flex flex-row justify-center">
                                <span>VRIJ</span>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <p v-else>Er zijn momenteel geen beschikbare data voor verjaardagsfeestjes in {{ new Date().getFullYear()}}.</p>
                    <hr/>
                </div>

                <div v-if="showVolgendJaar">
                    <h3 class="subheader">Beschikbare data {{ new Date().getFullYear() + 1 }}.</h3>
                    <table v-if="filteredVolgendJaar.length > 0" class="w-full table-auto">
                        <thead>
                        <tr>
                            <th>Dag</th>
                            <th>Datum</th>
                            <th>Startuur</th>
                            <th>Einduur</th>
                            <th class="flex flex-row justify-center">Volzet/vrij</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="dag in filteredVolgendJaar"
                            :key="dag.id"
                            :class="{ 'doorstreept': new Date(dag.startdatum) <= new Date()}">
                            <td>{{ weekdagen[new Date(dag.startdatum).getDay()] }}</td>
                            <td>{{
                                    new Date(dag.startdatum).toLocaleDateString('nl-BE', {
                                        year: 'numeric',
                                        month: 'long',
                                        day: 'numeric'
                                    })
                                }}
                            </td>
                            <td>{{ dag.startuur.substring(0, 5) }}</td>
                            <td>{{ dag.einduur.substring(0, 5) }}</td>
                            <td v-if="getVolzet(dag)" class="flex flex-row justify-center">
                                <span>VOLZET</span>
                            </td>
                            <td v-else class="flex flex-row justify-center">
                                <span>VRIJ</span>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <p v-else>Er zijn momenteel geen beschikbare data voor verjaardagsfeestjes in {{ new Date().getFullYear() + 1}}.</p>
                    <hr/>
                </div>
                <h3 class="subheader">Reservatie</h3>
                <h4>Bezorg ons volgende gegevens via info@kleinvossenpark.be:</h4>
                <ul class="bday">
                    <li>Naam en leeftijd van de jarige</li>
                    <li>Gewenste datum</li>
                    <li>Verwacht aantal deelnemende kinderen</li>
                    <li><strong>Enkele dagen voor aanvang feestje:</strong> Aantal deelnemende kinderen doorgeven</li>
                    <li><strong>Praktisch:</strong> bij de uitnodiging best meedelen dat het een actief feestje is
                        binnen en buiten, samen met de dieren en dat daarom best aangepaste seizoens-/speelkledij
                    en/of laarsjes voorzien worden.
                </li>
            </ul>
            <blockquote>
                <h4>Betaling: <br>
                    <br>
                    <span>Gelieve bij aanvang feestje de betaling uit te voeren: <br>
                                    cash of via bank app met QR-code.</span></h4>
            </blockquote>
            <p><strong>Extra info gewenst? Bel gerust: 0477 36 36 63, Koen.</strong></p>
            </div>

            <div class="md:w-2/6">
                <lightbox-gallery folder="Afbeeldingen/Activiteiten/Verjaardagsfeest" :max_images_thumbs="12"/>
                <div class="panel mt-4">
                    <h4 class="text-center">Uitnodiging</h4>
                    <p class="text-center">Download hier onze invulbare uitnodiging voor jouw verjaardagsfeestje!</p>
                    <PrimaryButton @click="download()">Download</PrimaryButton>
                </div>
            </div>
        </div>
    </div>
    </WebPageLayout>
</template>

<script>
export default {
    name: "Verjaardagsfeest",
    data() {
        return {
            weekdagen: ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'],
        }
    },
    methods: {
        getVolzet(dag) {
            //Get the verjaardagactiviteit van de dag
            let activiteit = dag.activiteiten.filter(activiteit => activiteit.naam === "Verjaardagsfeest")[0];
            return activiteit.pivot.volzet === 1;
        },
        download() {
            window.open("/public/storage/Documenten/Uitnodiging/Uitnodiging_verjaardag.pdf", "_blank");
        }
    },
    computed: {
        showVolgendJaar() {
            return new Date().getMonth() >= 9;
        },
        prijs_kind() {
            return this.prijzen.types.filter(type => type.naam.includes("kind"))[0];
        },
        prijs_groep() {
            return this.prijzen.types.filter(type => type.naam.includes("groep"))[0];
        },
        filteredBeschikbaarheden() {
            return this.beschikbaarheden_verjaardag.filter( beschikbaarheid => {
                return beschikbaarheid.activiteiten.filter(activiteit => activiteit.naam === "Verjaardagsfeest").length > 0
            }) || []

        },
        filteredDitJaar() {
            return this.filteredBeschikbaarheden.filter(beschikbaarheid => new Date(beschikbaarheid.startdatum).getFullYear() === new Date().getFullYear() && new Date(beschikbaarheid.startdatum) > new Date())
        },
        filteredVolgendJaar() {
            return this.filteredBeschikbaarheden.filter(beschikbaarheid => new Date(beschikbaarheid.startdatum).getFullYear() === new Date().getFullYear() + 1)
        }
    },
    created() {


    }
}
</script>

<style scoped>

ul > li {
    list-style: disc;
}

ul {
    padding-left: 1em;
}

.text-kvpDanger {
    color: red !important;
}

.doorstreept {
    position: relative;
}

.doorstreept::after {
    content: "";
    position: absolute;
    top: 47%;
    left: 1%;
    width: 98%;
    height: 2px;
    background-color: rgba(43, 43, 43, 1);
}

</style>
